export default __webpack_public_path__ + "static/media/SomeGuy_x1024.03e740b9.png";